import React, { useState } from "react";
import {
  Container,
  Row,
  Col,
  Button,
} from "react-bootstrap";

import {
  FiPlusCircle,
} from "react-icons/fi";
import PayrollTabs from "../../../components/financial&accounts/PayrollItems/PayrollTabs";
import PayrollTable from "../../../components/financial&accounts/PayrollItems/PayrollTable";
import AddAdditionModal from "../../../components/modals/financial&accounts/payrollitems/AddAdditionModal";
import AddOvertimeModal from "../../../components/modals/financial&accounts/payrollitems/AddOvertimeModal";
import AddDeductionModal from "../../../components/modals/financial&accounts/payrollitems/AddDeductionModal";
import EditPayrollModal from "../../../components/modals/financial&accounts/payrollitems/EditPayrollModal";
import DeletePayrollModal from "../../../components/modals/financial&accounts/payrollitems/DeletePayrollModal";
import PayrollItemsHeader from "../../../components/financial&accounts/payroll/PayrollItemsHeader";

// import PayrollTabs from "../components/payroll/PayrollTabs";
// import PayrollTable from "../components/payroll/PayrollTable";

// import AddAdditionModal from "../components/payroll/AddAdditionModal";
// import AddOvertimeModal from "../components/payroll/AddOvertimeModal";
// import AddDeductionModal from "../components/payroll/AddDeductionModal";

// import EditPayrollModal from "../components/payroll/EditPayrollModal";
// import DeletePayrollModal from "../components/payroll/DeletePayrollModal";



export default function PayrollItems() {

  const [activeTab, setActiveTab] = useState("addition");

  const [showAdditionModal, setShowAdditionModal] = useState(false);
  const [showOvertimeModal, setShowOvertimeModal] = useState(false);
  const [showDeductionModal, setShowDeductionModal] = useState(false);

  const [showEditModal, setShowEditModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);

  const [selectedItem, setSelectedItem] = useState(null);

  const [additionData, setAdditionData] = useState([
    {
      id: 1,
      name: "Leave Balance Amount",
      category: "Monthly Remuneration",
      amount: "$5",
    },
    {
      id: 2,
      name: "Arrears of Salary",
      category: "Additional Remuneration",
      amount: "$8",
    },
    {
      id: 3,
      name: "Gratuity",
      category: "Monthly Remuneration",
      amount: "$20",
    },
  ]);

  const [overtimeData, setOvertimeData] = useState([
    {
      id: 1,
      name: "Normal day OT 1.5x",
      rate: "Hourly 1.5",
    },
    {
      id: 2,
      name: "Public holiday OT 3.0x",
      rate: "Hourly 3",
    },
    {
      id: 3,
      name: "Rest day OT 2.0x",
      rate: "Hourly 2",
    },
  ]);

  const [deductionData, setDeductionData] = useState([
    {
      id: 1,
      name: "Absent amount",
      amount: "$12",
    },
    {
      id: 2,
      name: "Advance",
      amount: "$7",
    },
    {
      id: 3,
      name: "Unpaid leave",
      amount: "$3",
    },
  ]);

  const openEdit = (item) => {
    setSelectedItem(item);
    setShowEditModal(true);
  };

  const openDelete = (item) => {
    setSelectedItem(item);
    setShowDeleteModal(true);
  };

  const handleDelete = () => {
    if (activeTab === "addition") {
      setAdditionData(additionData.filter((i) => i.id !== selectedItem.id));
    }

    if (activeTab === "overtime") {
      setOvertimeData(overtimeData.filter((i) => i.id !== selectedItem.id));
    }

    if (activeTab === "deduction") {
      setDeductionData(deductionData.filter((i) => i.id !== selectedItem.id));
    }

    setShowDeleteModal(false);
  };

  const getData = () => {
    if (activeTab === "addition") return additionData;
    if (activeTab === "overtime") return overtimeData;
    return deductionData;
  };

  return (
  <div   style={{ padding: "15px", background: "#f8f9fa",  }} >
<PayrollItemsHeader/>
      <Container fluid className="payroll-page">

      <Row className="align-items-center mb-4 g-3">
        <Col lg={8}>
          <PayrollTabs
            activeTab={activeTab}
            setActiveTab={setActiveTab}
          />
        </Col>

        <Col
          lg={4}
          className="text-lg-end text-start"
        >
          {activeTab === "addition" && (
            <Button
              className="add-btn"
              onClick={() => setShowAdditionModal(true)}
            >
              <FiPlusCircle className="me-2" />
              Add Addition
            </Button>
          )}

          {activeTab === "overtime" && (
            <Button
              className="add-btn"
              onClick={() => setShowOvertimeModal(true)}
            >
              <FiPlusCircle className="me-2" />
              Add Overtime
            </Button>
          )}

          {activeTab === "deduction" && (
            <Button
              className="add-btn"
              onClick={() => setShowDeductionModal(true)}
            >
              <FiPlusCircle className="me-2" />
              Add Deduction
            </Button>
          )}
        </Col>
      </Row>

      <PayrollTable
        activeTab={activeTab}
        data={getData()}
        onEdit={openEdit}
        onDelete={openDelete}
      />

      {/* ADD MODALS */}

      <AddAdditionModal
        show={showAdditionModal}
        handleClose={() => setShowAdditionModal(false)}
      />

      <AddOvertimeModal
        show={showOvertimeModal}
        handleClose={() => setShowOvertimeModal(false)}
      />

      <AddDeductionModal
        show={showDeductionModal}
        handleClose={() => setShowDeductionModal(false)}
      />

      {/* EDIT MODAL */}

      <EditPayrollModal
        show={showEditModal}
        handleClose={() => setShowEditModal(false)}
        selectedItem={selectedItem}
      />

      {/* DELETE MODAL */}

      <DeletePayrollModal
        show={showDeleteModal}
        handleClose={() => setShowDeleteModal(false)}
        handleDelete={handleDelete}
      />
<style>
     {
          `
          
          body {
  background: #f5f6f8;
}

// .payroll-page {
//   padding: 25px;
// }

.tabs-wrapper {
  display: flex;
  gap: 14px;
  flex-wrap: wrap;
}

.tab-btn {
  background: #fff !important;
  color: #111 !important;
  border: 1px solid #ddd !important;
  padding: 11px 22px !important;
  border-radius: 8px !important;
  font-weight: 500 !important;
}

.active-tab {
  background: #0d4f63 !important;
  color: #fff !important;
  border-color: #0d4f63 !important;
}

.add-btn {
  background: #f97316 !important;
  border: none !important;
  padding: 12px 22px !important;
  border-radius: 8px !important;
  font-weight: 600 !important;
}

.table-card {
  border-radius: 12px !important;
  overflow: hidden;
}

.table-header {
  background: #fff !important;
  padding: 22px !important;
  border-bottom: 1px solid #eee !important;

  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 15px;
}

.table-title {
  font-size: 18px;
  font-weight: 660;
  margin: 0;
}

.sort-btn {
  background: #fff !important;
  color: #111 !important;
  border: 1px solid #ddd !important;
  padding: 10px 18px !important;
}

.filter-bar {
  padding: 18px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 20px;
}

.entries-wrapper {
  display: flex;
  align-items: center;
  gap: 12px;
}

.entries-select {
  width: 80px !important;
}

.search-input {
  width: 260px !important;
}

.custom-table thead {
  background: #efefef;
}

.custom-table th {
  padding: 16px !important;
  white-space: nowrap;
}

.custom-table td {
  padding: 20px 16px !important;
  white-space: nowrap;
}

.action-icons {
  display: flex;
  align-items: center;
  gap: 18px;
}

.action-icon {
  font-size: 18px;
  cursor: pointer;
  color: #6b7280;
}

.pagination-wrapper {
  padding: 20px;
  align-items: center;
}

.page-number {
  width: 35px;
  height: 35px;
  border-radius: 50%;
  background: #f97316;
  color: #fff;

  display: inline-flex;
  align-items: center;
  justify-content: center;
}

/* MODAL */

.modal-content {
  border-radius: 16px !important;
  border: none !important;
}

.modal-header {
  border-bottom: 1px solid #eee !important;
  padding: 20px !important;
}

.modal-body {
  padding: 24px !important;
}

.form-control,
.form-select {
  height: 48px;
  border-radius: 8px !important;
}

.save-btn {
  background: #0d4f63 !important;
  border: none !important;
  height: 48px;
  border-radius: 10px !important;
  font-weight: 600 !important;
}

/* MOBILE */

@media (max-width: 768px) {

  .payroll-page {
    padding: 15px;
  }

  .table-title {
    font-size: 22px;
  }

  .search-input {
    width: 100% !important;
  }

  .filter-bar {
    flex-direction: column;
    align-items: stretch;
  }

  .entries-wrapper {
    flex-wrap: wrap;
  }

  .table-header {
    flex-direction: column;
    align-items: flex-start;
  }

  .add-btn {
    width: 100%;
  }

  .tab-btn {
    width: 100%;
  }
}`
     }
</style>
    </Container>
  </div>
  );
}